import React from 'react'
import { AppleFilled, AndroidFilled, ChromeFilled } from '@ant-design/icons'

import { NotificationDeliverySpec } from '@pushly/models/lib/structs/notification-delivery-spec'
import { NotificationDeliveryType } from '@pushly/models/lib/enums/notification-delivery-type'
import { NotificationDeliveryWindow } from '@pushly/models/lib/enums/notification-delivery-window'

/** Channel icon + label mapping shared across notification views */
export const CHANNEL_LABELS: Record<string, { icon: React.ReactNode; label: string }> = {
    WEB: { icon: <ChromeFilled />, label: 'Web' },
    NATIVE_IOS: { icon: <AppleFilled />, label: 'iOS' },
    NATIVE_ANDROID: { icon: <AndroidFilled />, label: 'Android' },
}

/** Derives a human-readable delivery strategy label from a notification's delivery_spec */
export function getDeliveryStrategyLabel(notif: {
    source?: string
    delivery_spec?: NotificationDeliverySpec
}): string | undefined {
    const spec = notif?.delivery_spec
    if (!spec) return undefined
    if (notif?.source === 'campaign') return 'Journey Schedule'
    const window = spec.window
    const type = spec.type
    if (window === NotificationDeliveryWindow.HOLD_OUT) return 'Hold Out'
    if (window === NotificationDeliveryWindow.INFORMED) return 'Informed'
    if (type === NotificationDeliveryType.IMMEDIATE) return 'Immediate'
    if (window === NotificationDeliveryWindow.STANDARD) return 'Fixed'
    if (window === NotificationDeliveryWindow.TIMEZONE) return 'Subscriber Time Zone'
    return undefined
}

export interface CompactNumber {
    display: string
    full: string
    isCompact: boolean
}

/** Formats a number compactly (183,128 → "183.1k") */
export function formatCompact(value: number): CompactNumber {
    const full = value.toLocaleString()
    if (value >= 1_000_000) {
        return { display: `${(value / 1_000_000).toFixed(1)}M`, full, isCompact: true }
    }
    if (value >= 10_000) {
        return { display: `${(value / 1_000).toFixed(1)}k`, full, isCompact: true }
    }
    return { display: full, full, isCompact: false }
}

/** Shorthand: returns just the display string (for simpler use cases) */
export function formatCompactDisplay(value: number): string {
    return formatCompact(value).display
}
